import React from 'react';

function Modal({ isOpen, onClose, title, children }) {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4 overflow-y-auto">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-2xl my-8 overflow-y-auto max-h-[calc(100vh-8rem)]">
                <div className="flex justify-between items-center mb-4 sticky top-0 bg-white pt-1 pb-3 z-10">
                    <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl">&times;</button>
                </div>
                <div>{children}</div>
            </div>
        </div>
    );
}

export default Modal;